<template>
<v-toolbar flat dense >

  <v-icon small class="mr-2" >{{icon}}</v-icon>
  <v-toolbar-title >{{fullName}}'s operation hours</v-toolbar-title>

  <v-btn :key="membership.id"
    v-for="membership in practitioner.memberships"
    class="ml-3" color="primary"
    :outlined="!member || membership.id !== member.id" small
    :disabled="membership.is_active===false || membership.is_archived===true"
    @click="setMember(membership)" >
      {{membership.service_data.title}}
  </v-btn>

  <v-spacer/>
  <slot></slot>
  <v-divider vertical />
  <v-btn @click="member=null;$emit('close')" icon >
    <v-icon>mdi-close</v-icon>
  </v-btn>

  <template slot="extension" >
    <v-btn small outlined
      v-for="p in practitioners"
      color="info" class="mr-2"
      :key="p.id" >{{ p.full_name }}</v-btn>
  </template>
</v-toolbar>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MemberActionsToolbar',
  props: {
    practitioner: { type: Object },
    member: { type: Object },
    icon: { type: String },
    title: { type: String }
  },
  methods: {
    setMember (membership) {
      this.$emit('update:member', membership)
    }
  },
  watch: {
    memberships: {
      immediate: true,
      handler () {
        if (!this.member && this.memberships && this.memberships.length > 0) {
          this.$emit('update:member', this.memberships[0])
        }
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getPractitionersInSpace']),
    fullName () {
      let fn = this.getObjectPath(this.practitioner, 'user.first_name')
      let ln = this.getObjectPath(this.practitioner, 'user.last_name')
      return `${fn} ${ln}`
    },
    memberships () {
      return this.getObjectPath(this.practitioner, 'memberships', [])
    },
    spaceId () {
      return this.getObjectPath(this.member, 'service')
    },
    practitioners () {
      if (this.spaceId) {
        return this.getPractitionersInSpace(this.spaceId)
      }
      return []
    }
  }
}
</script>
